import UiButton from 'components/ui/button/Button'
import { getCashFlowTableData } from 'components/ui/cash-flow-table/utils'
import { VIEW_CASH_FLOW_CHART_CUSTOMIZATION, VIEW_CASH_FLOW_CUSTOMIZATION } from 'constants/UserClicksConstant'
import AuthStore from 'modules/login/store/AuthStore'
import React, { useState } from 'react'
import { Image } from 'react-bootstrap'
import Modal from "react-bootstrap/Modal"
import ModalBody from "react-bootstrap/ModalBody"
import * as images from "constants/Images"
import "./ProductGraph.css"
import CustomizationLoader from 'components/ui/customization-loader/CustomizationLoader'
import OptimizationStore from 'modules/optimization/store/OptimizationStore'

const ProductGraphModal = (props) => {

    const [showProductGraph, setShowProductGraph] = useState(false)
    const [state, setState] = useState({
        showLoader: false,
        data: { policyTimeLineData: [] },
        yearsLength: [],
        pointsPlots: []
    })
    const [isYouGet, setIsYouGat] = useState(true)


    function getHeight(value) {
        if (value === 0) {
            return '0px';
        }
        let height = '0px';
        switch (true) {
            case value < 1:
                height = '0px';
                break;
            case value < 1000:
                height = '3px';
                break;
            case value >= 1000 && value < 10000:
                height = '7px';
                break;
            case value >= 10000 && value < 50000:
                height = '9px';
                break;
            case value >= 50000 && value < 100000:
                height = '13px';
                break
            case value >= 100000 && value < 500000:
                height = '17px';
                break;
            case value >= 500000 && value < 1000000:
                height = '23px';
                break;
            case value >= 1000000 && value < 5000000:
                height = '33px';
                break;
            case value >= 5000000 && value < 10000000:
                height = '37px';
                break;
            case value >= 10000000 && value < 50000000:
                height = '41px';
                break;
            case value >= 50000000 && value < 100000000:
                height = '46px';
                break;
            case value >= 100000000 && value < 150000000:
                height = '51px';
                break;
            case value >= 150000000 && value < 250000000:
                height = '55px';
                break;
            case value > 250000000:
                height = '60px';
                break;
            default:
                height = '0px';
                break;
        }
        const multipliedHeight = parseInt(height) * 3 + 'px';
        return multipliedHeight;
    }



    const showCashFlowTableModal = async () => {
        //! for save user clicks
        setShowProductGraph(true);
        AuthStore.saveUserClicks(VIEW_CASH_FLOW_CHART_CUSTOMIZATION)
        const response = await getCashFlowTableData(props?.productData)
        let policyTimeLineData = response?.data
        let newARR = [];
        let isYouGet = policyTimeLineData?.header_list?.includes("You Get")
        setIsYouGat(isYouGet)
        if (isYouGet) {
            policyTimeLineData?.primary_la_list?.forEach((item, index) => {
                let obj = {}
                obj['key'] = index + 1
                obj['value'] = 'YouGet';
                obj['height'] = getHeight(item.you_get)
                newARR.push(obj)
            })
        } else {
            policyTimeLineData?.primary_la_list?.forEach((item, index) => {
                let obj = {}
                obj['key'] = index + 1
                obj['value'] = 'LifeCover';
                obj['height'] = getHeight(item.life_cover)
                newARR.push(obj)
            })
        }


        policyTimeLineData?.primary_la_list?.forEach((item, index) => {
            let obj = {}
            obj['key'] = index + 1
            obj['value'] = 'YouPay';
            obj['height'] = getHeight(item.you_pay)
            newARR.push(obj)
        })
        setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                policyTimeLineData: policyTimeLineData?.primary_la_list
            },
            yearsLength: Array.from({ length: policyTimeLineData?.primary_la_list?.length }, (_, index) => index + 1),
            showLoader: false,
            pointsPlots: newARR
        }));

    }

    console.log(state?.data, "dataData")

    const [isLandscape, setIsLandscape] = useState(
        window.matchMedia("(orientation: landscape)").matches
    );

    // useEffect(() => {
    //     const handleOrientationChange = () => {
    //         setIsLandscape(window.matchMedia("(orientation: landscape)").matches);
    //     };

    //     window.addEventListener("resize", handleOrientationChange);

    //     return () => {
    //         window.removeEventListener("resize", handleOrientationChange);
    //     };
    // }, []);

    const pointStyle = {
        textAlign: "center",
        position: "relative",
    };



    const getPointPlotStyle = (key, value, height, pt) => {
        let weight = Math.round(window.innerWidth - pt * 14)
        let size = Math.round(weight / pt) / 3 < 0 ? 2 : Math.round(weight / pt) / 3 > 2 ? Math.round(weight / pt) / 3 : 2


        const borderStyle = height !== '0px' ? ((value === 'YouGet' || value === "LifeCover") ? `${size}px solid rgb(31, 31, 193)` : `${size}px solid  rgb(205, 89, 0)`) : 'none';

        let style = {
            position: "absolute",
            border: borderStyle,
            height: height,
            marginLeft: "2px",
        };

        if (value === "YouGet" || value === "LifeCover") {
            style = {
                ...style,
                marginBottom: "25px",
                bottom: 0,

            };
        } else if (value === "YouPay") {
            style = {
                ...style,
                top: 0,

            };
        }

        return style;
    };


    const Numberstyle = (pt, point) => {
        let weight = Math.round(window.innerWidth - pt * 14)
        let size = Math.round(weight / pt) / 3 < 0 ? 2 : Math.round(weight / pt) / 3 > 2 ? Math.round(weight / pt) / 3 : 2
        let style = {
            position: 'relative',
            paddingRight: point > 9 ? size + 'px' : size + 3 + 'px',
            paddingLeft: point > 9 ? size + 'px' : size + 3 + 'px',
            top: '2px',
            right: '5px',
            fontSize: window.innerWidth < 1000 ? '12px ' : '14px',
            zIndex: "99999",
            color: 'black',
        };
        return style
    }

    const closeModal = () => {

        setShowProductGraph(false),
            setState(prevState => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    policyTimeLineData: []
                },
                yearsLength: [],
                showLoader: false,
                pointsPlots: []
            }))
    }

    return (
        <div className="">
            <span
                className="btn text-primary p-0 LA-btn font-size-14 font-size-md-12 font-weight-light ml-0 ml-md-1"
                onClick={() => showCashFlowTableModal()}
            >
                [ View Cashflow Chart]
            </span>

            {OptimizationStore.showGraphTooltip &&
                <>
                    <div class="tooltip-graph-product row">
                        <div className="col-10  px-0 tooltip-text">
                            Checkout Graph for the Cashflows
                        </div>
                        <div className="col-2 px-0">
                            <Image
                                className="close-icon-graph-product"
                                src={images.CloseIconBlack}
                                    onClick={() => { OptimizationStore.setGraphTooltip(false)}}
                            />
                        </div>

                    </div>
                </>
            }
            <Modal
                show={showProductGraph}
                onHide={() => setShowProductGraph(false)}
                aria-labelledby=""
                className='ProductGraphModal'
                centered
                keyboard={false}
            >
                <Modal.Header
                    closeButton={false}
                    className="pb-0 mx-md-2 border-bottom-0 cashFlow-table-header"
                >
                    <div className="d-flex justify-content-between w-100">
                        <div className="">
                            <p className="font-size-16 font-weight-medium text-primary">{props?.productName} - TimeGraph</p>
                        </div>
                        <UiButton
                            variant=""
                            className="d-inline-flex align-self-start justify-content-end p-0 ml-2"
                            onClick={() => closeModal()}
                        >
                            <span className="mr-2 cancel-btn-style">Cancel</span>
                            <Image
                                className="close-icon-class"
                                src={images.CrossIcon}
                            />
                        </UiButton>
                    </div>
                </Modal.Header>
                <ModalBody >
                    <>

                        <span className='youPayLabel'>You Pay</span>
                        <span className='youGetLabel'>{isYouGet ? 'You Get' : 'Protection Cover'}</span>
                        <div className="graph-page graph-grid" >
                            {state.yearsLength?.length > 0 ?
                                <>
                                    {
                                        state.yearsLength?.map((point, pointIndex) => {
                                            const matchingPoints = state?.pointsPlots?.filter((specialPoint) => specialPoint?.key === point);
                                            console.log("matchingPoints ", matchingPoints)
                                            return (
                                                <div style={{ borderTop: "1px solid black", marginBottom: '15px' }} key={pointIndex}>
                                                    <div style={pointStyle}>


                                                        {/* {point % 2 === 0 && */}
                                                        <span style={Numberstyle(state.yearsLength?.length, point)}>
                                                            {point}
                                                        </span>
                                                        {/* } */}
                                                        {matchingPoints.length > 0 && matchingPoints?.map((plot, plotIndex) => {
                                                            const plotStyle = getPointPlotStyle(plot.key, plot.value, plot.height, state.yearsLength?.length);

                                                            return (
                                                                <div key={plotIndex} style={plotStyle}></div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </>
                                :
                                <div className='w-100 text-center'>
                                    <CustomizationLoader />
                                </div>
                            }
                        </div>
                    </>
                </ModalBody>
            </Modal>
        </div>

    )
}

export default ProductGraphModal